import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';
import Tippy from '../components/ReactTippy';
import {
  AGENCY_REGISTRATION_APPLICATION_PAGE,
  AGENCY_REGISTRATION_APPLICATION_STATUS,
  HEADER_CONSTANTS,
  REQUEST_PARAMS,
  ONE_MASTER_FLAG,
} from '../utilities/constants';
import { MasterPageHeader } from '../components/PageHeader';
import masterSlideLoader from '../utilities/masterSlideLoader';
import dialogLoader from '../utilities/dialogLoader';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import AgencyRegistrationApplicationService from '../services/AgencyRegistrationApplications';
import DropdownSelector from '../components/dropdowns/DropdownSelector';
import useAgencyRegistrationApplicationDownLoader from '../components/useAgencyRegistrationApplicationDownLoader';
import AgencyRegistrationApplicationAttention, {
  DISPLAY_MODE,
} from '../components/AgencyRegistrationApplicationAttention';
import AgencyRegistrationApplicationHistoryDialog from '../components/AgencyRegistrationApplicationHistoryDialog';
import AgencyRegistrationApplicationStatus from '../components/AgencyRegistrationApplicationStatus';

const createInitialSearchParam = () => ({
  limit: REQUEST_PARAMS.parentLimit,
  offset: 0,
});

const AgencyRegistrationApplications = () => {
  const [applications, setApplications] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [allLoaded, setAllLoaded] = useState(false);
  // 検索項目の表示用の値
  const [applicationNo, setApplicationNo] = useState(null);
  // const [statusList, setStatusList] = useState([]);
  const [companyName, setCompanyName] = useState(null);
  const [address, setAddress] = useState(null);
  const [tel, setTel] = useState(null);
  const [oneMasterFlags, setOneMasterFlags] = useState([]);
  const [latestStatuses, setLatestStatuses] = useState([
    AGENCY_REGISTRATION_APPLICATION_STATUS.NOT_APPLIED.ID.toString(),
    AGENCY_REGISTRATION_APPLICATION_STATUS.APPLIED.ID.toString(),
    AGENCY_REGISTRATION_APPLICATION_STATUS.REJECTED.ID.toString(),
  ]);
  // 実際に検索する際のパラメータ
  const [searchParam, setSearchParam] = useState({
    limit: REQUEST_PARAMS.parentLimit,
    offset: 0,
    one_master_flags: oneMasterFlags,
    latest_statuses: latestStatuses,
  });

  const {
    wordTemplateDownLoad,
    pdfTemplateDownLoad,
  } = useAgencyRegistrationApplicationDownLoader();

  // 読込処理
  useEffect(
    () => {
      (async () => {
        let isError = false;
        const isAdd = searchParam.offset !== 0;
        const clearList = () => {
          setApplications([]);
          setTotal(0);
        };

        setIsLoading(true);
        if (!isAdd) {
          clearList();
        }

        // applicationNoは文字列のみ
        if (_.isNumber(applicationNo)) {
          isError = true;
        } else {
          const response = await AgencyRegistrationApplicationService.list(
            searchParam
          );
          if (response.result) {
            const list =
              response.data.entities.agency_registration_applications.companies;
            setAllLoaded(_.size(list) < searchParam.limit);
            setApplications(prev => {
              return isAdd ? [...prev, ...list] : list;
            });
            setTotal(response.data.total);
          } else {
            isError = true;
          }
        }

        if (isError && !isAdd) {
          clearList();
        }
        setIsLoading(false);
      })();
    },
    [searchParam]
  );

  // 検索
  const search = () => {
    setSearchParam({
      application_no: applicationNo ? applicationNo : null,
      // status: _.size(statusList) > 0 ? statusList : null,
      name: companyName ? companyName : null,
      address: address ? address : null,
      tel: tel ? tel : null,
      one_master_flags: oneMasterFlags ? oneMasterFlags : [],
      latest_statuses: latestStatuses ? latestStatuses : [],
      limit: REQUEST_PARAMS.parentLimit,
      offset: 0,
    });
  };

  // 無限スクロールの追加読込
  const handleScroll = () => {
    if (!allLoaded) {
      setSearchParam(prev => ({
        ...prev,
        offset: prev.offset + REQUEST_PARAMS.parentLimit,
      }));
    }
  };

  const setSearchValue = e => {
    switch (e.target.name) {
      case 'applicationNo':
        setApplicationNo(e.target.value);
        break;
      case 'companyName':
        setCompanyName(e.target.value);
        break;
      case 'address':
        setAddress(e.target.value);
        break;
      case 'tel':
        setTel(e.target.value);
        break;
      default:
        break;
    }
  };

  const setStatusList = id => {
    const statusId = _.toString(id);
    if (latestStatuses.includes(statusId)) {
      setLatestStatuses(latestStatuses.filter(item => item !== statusId));
    } else {
      setLatestStatuses(latestStatuses.concat(statusId));
    }
  };

  const setMasterFlagList = id => {
    const masterFlagId = _.toString(ONE_MASTER_FLAG[id]['id']);
    if (oneMasterFlags.includes(masterFlagId)) {
      setOneMasterFlags(oneMasterFlags.filter(item => item !== masterFlagId));
    } else {
      setOneMasterFlags(oneMasterFlags.concat(masterFlagId));
    }
  };

  const searchValuesClear = () => {
    setApplicationNo(null);
    setLatestStatuses([]);
    setCompanyName(null);
    setAddress(null);
    setTel(null);
    setOneMasterFlags([]);
    setLatestStatuses([]);
    setSearchParam(createInitialSearchParam());
  };

  const moveDetailPage = id => {
    masterSlideLoader.show(
      AGENCY_REGISTRATION_APPLICATION_PAGE.DETAIL.COMPONENT_NAME,
      {
        state: { id },
      }
    );
  };

  const moveRegisterPage = () => {
    masterSlideLoader.show(
      AGENCY_REGISTRATION_APPLICATION_PAGE.REGISTER.COMPONENT_NAME,
      {
        state: {},
      }
    );
  };

  return (
    <div className='master-slide-view show'>
      <Helmet>
        <title>
          {`${HEADER_CONSTANTS.conference} - ${
            AGENCY_REGISTRATION_APPLICATION_PAGE.LIST.TEXT
          }`}
        </title>
      </Helmet>
      <div className='master-slide-view__view'>
        <MasterPageHeader
          title={AGENCY_REGISTRATION_APPLICATION_PAGE.LIST.TEXT}
          onClose={() => masterSlideLoader.close()}
        />
        <div id='infinityscroll-target' className='master-slide-view__table'>
          <div className='master-slide-view__menu'>
            <ul className='btn-menu'>
              <li className='btn-menu__item'>
                <button className='btn' onClick={moveRegisterPage}>
                  新規申請
                </button>
              </li>
              <li className='btn-menu__item'>
                <div className='master-slide-view__menu__vertical-bar' />
              </li>
              <li className='btn-menu__item'>
                <button className='btn--sub' onClick={wordTemplateDownLoad}>
                  覚書テンプレートダウンロード（Word）
                </button>
              </li>
              <li className='btn-menu__item'>
                <button className='btn--sub' onClick={pdfTemplateDownLoad}>
                  覚書テンプレートダウンロード（PDF）
                </button>
              </li>
            </ul>
          </div>
          <AgencyRegistrationApplicationAttention
            displayMode={DISPLAY_MODE.AgencyRegistrationApplications}
          />
          <SearchForm
            {...{
              total,
              applicationNo,
              // statusList,
              companyName,
              address,
              tel,
              latestStatuses,
              oneMasterFlags,
              setSearchValue,
              setMasterFlagList,
              setStatusList,
              searchValuesClear,
              search,
            }}
          />
          <AgencyLegend />
          <div className='master-slide-view__body'>
            <AgencyRegistrationApplicationsTable
              applications={applications}
              moveDetailPage={moveDetailPage}
            />
            <InfinityScrollLoad
              targetId={`infinityscroll-target`}
              total={applications.length}
              isLoading={isLoading}
              callback={handleScroll}
              ignoreIndicator={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const AgencyLegend = ({ props }) => {
  return (
    <div className='AgencyLegend'>
      <div className='AgencyLegend__item'>
        <AgencyRegistrationApplicationStatus status={3} />
        <span className='AgencyLegend__item-text'>再申請が必要です</span>
      </div>
      <div className='AgencyLegend__item'>
        <AgencyRegistrationApplicationStatus status={0} />
        <span className='AgencyLegend__item-text'>申請が完了していません</span>
      </div>
    </div>
  );
};

const SearchForm = ({
  total,
  applicationNo,
  companyName,
  address,
  tel,
  latestStatuses,
  oneMasterFlags,
  setSearchValue,
  setStatusList,
  setMasterFlagList,
  searchValuesClear,
  search,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className='master-slide-view__searchform_no_border'>
      <div className='search-form'>
        <div className='search-form__header'>
          <div className='search-form__title'>
            検索条件（検索結果<span className='bold'>{total}</span>件)
          </div>
          <button
            id='accordion-toggle'
            className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
            onClick={() => toggle()}
          />
          <button className='btn-text--sm' onClick={searchValuesClear}>
            検索条件クリア
          </button>
        </div>
        <div
          id='search-form-accordion'
          className={isOpen ? 'accordion show' : 'accordion'}
        >
          <div className='search-form__body'>
            <div className='form form--search-form'>
              <div className='form__group flex-wrap'>
                <div className='form-element'>
                  <div className='form-element__label'>
                    <span className='label'>申請No</span>
                  </div>
                  <div className='form-element__element'>
                    <input
                      type='text'
                      name='applicationNo'
                      placeholder='申請No'
                      value={applicationNo || ''}
                      onChange={setSearchValue}
                      maxLength='18'
                    />
                  </div>
                </div>
                <div className='form-element'>
                  <div className='form-element__label'>
                    <span className='label'>会社名</span>
                  </div>
                  <div className='form-element__element'>
                    <input
                      type='text'
                      name='companyName'
                      placeholder='会社名'
                      value={companyName || ''}
                      onChange={setSearchValue}
                    />
                  </div>
                </div>
                <div className='form-element'>
                  <div className='form-element__label'>
                    <span className='label'>住所</span>
                  </div>
                  <div className='form-element__element'>
                    <input
                      type='text'
                      name='address'
                      placeholder='住所'
                      value={address || ''}
                      onChange={setSearchValue}
                    />
                  </div>
                </div>
                <div className='form-element'>
                  <div className='form-element__label'>
                    <span className='label'>電話番号</span>
                  </div>
                  <div className='form-element__element'>
                    <input
                      type='text'
                      name='tel'
                      placeholder='電話番号'
                      value={tel || ''}
                      onChange={setSearchValue}
                    />
                  </div>
                </div>
                <div className='form-element'>
                  <div className='form-element__label'>
                    <span className='label'>会社種別</span>
                  </div>
                  <div className='form-element__element'>
                    <ul className='search-form__checklist'>
                      {['corporation', 'personal'].map(masterFlag => {
                        return (
                          <label
                            htmlFor={masterFlag}
                            className='checkbox'
                            key={`checkbox-masterflag-${masterFlag}`}
                            onClick={() => {
                              setMasterFlagList(masterFlag);
                            }}
                          >
                            <input
                              type='checkbox'
                              name={masterFlag}
                              checked={oneMasterFlags.includes(
                                ONE_MASTER_FLAG[masterFlag]['id'].toString()
                              )}
                              readOnly
                            />
                            <i
                              className='i-square-checkbox i-2_5x'
                              aria-hidden='true'
                            />
                            <span className='radio-search-span'>
                              {masterFlag &&
                                ONE_MASTER_FLAG[masterFlag]['name']}
                            </span>
                          </label>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className='form-element'>
                  <div className='form-element__label'>
                    <span className='label'>ステータス</span>
                  </div>
                  <div className='form-element__element'>
                    <ul className='search-form__checklist'>
                      {[
                        'REJECTED',
                        'NOT_APPLIED',
                        'APPLIED',
                        'APPROVED',
                        'EXPIRED',
                      ].map(status => {
                        return (
                          <label
                            htmlFor='checkbox'
                            className='checkbox'
                            key={`checkbox-status-${
                              AGENCY_REGISTRATION_APPLICATION_STATUS[status][
                                'ID'
                              ]
                            }`}
                            onClick={() => {
                              setStatusList(
                                AGENCY_REGISTRATION_APPLICATION_STATUS[status][
                                  'ID'
                                ]
                              );
                            }}
                          >
                            <input
                              type='checkbox'
                              name='checkbox'
                              checked={latestStatuses.includes(
                                AGENCY_REGISTRATION_APPLICATION_STATUS[status][
                                  'ID'
                                ].toString()
                              )}
                              readOnly
                            />
                            <i
                              className='i-square-checkbox i-2_5x'
                              aria-hidden='true'
                            />
                            <span className='radio-search-span'>
                              {
                                AGENCY_REGISTRATION_APPLICATION_STATUS[status][
                                  'TEXT'
                                ]
                              }
                            </span>
                          </label>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className='form-element' style={{ paddingTop: 34 }}>
                  <button
                    className='btn--stay btn--wide'
                    style={{
                      position: 'relative',
                    }}
                    onClick={search}
                  >
                    検索
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ApplicationsStatusSelect = ({ selectedValues, onSelect }) => {
  return (
    <div className='form-element'>
      <div className='form-element__label'>
        <span className='label'>ステータス</span>
      </div>
      <DropdownSelector
        className='form-element'
        label='ステータスを選択'
        multiple={true}
        selectorName='status'
        api={async () =>
          // 内部でthenを使っているのでPromiseを返す必要がある
          _.map(AGENCY_REGISTRATION_APPLICATION_STATUS, v => ({
            name: v.TEXT,
            value: _.toString(v.ID),
          }))
        }
        apiProcess={response => {
          return {
            data: response,
            total: response.length,
          };
        }}
        apiParams={{}}
        selectedValues={selectedValues}
        keyName='name'
        valueName='value'
        onSelect={(_, values) => onSelect(values)}
      />
    </div>
  );
};

const AgencyRegistrationApplicationsTable = ({
  applications,
  moveDetailPage,
}) => {
  const showAgencyRegistrationApplicationHistoryDialog = application => {
    dialogLoader.show(AgencyRegistrationApplicationHistoryDialog, {
      state: { application, moveDetailPage },
      callback: {
        close: () => {
          // 登録をやめる
          dialogLoader.close();
        },
      },
    });
  };

  return (
    <div className='constructionlist__list'>
      <table className='table table--constructionlist__list'>
        <thead className='table__header'>
          <tr className='table__label'>
            <td className='value-table value-table--table__label'>会社名</td>
            <td className='value-table value-table--table__label'>住所</td>
            <td className='value-table value-table--table__label'>電話番号</td>
            <td className='value-table value-table--table__label'>会社種別</td>
            <td className='value-table value-table--table__label'>
              ステータス
            </td>
            <td className='value-table value-table--table__label'>申請履歴</td>
          </tr>
        </thead>
        <tbody>
          {_.map(applications, application => {
            return (
              <tr
                className={
                  application.latest_application_status ===
                  AGENCY_REGISTRATION_APPLICATION_STATUS.EXPIRED.ID
                    ? 'table__item table__item--disabled'
                    : 'table__item'
                }
                key={application.id}
              >
                <td className='value-table'>
                  <Tippy
                    duration={10}
                    distance={24}
                    arrowType='sharp'
                    delay={[500, 0]}
                    placement='bottom'
                    followCursor={true}
                    html={
                      <div className='data-table__tooltip'>
                        {application.name}
                      </div>
                    }
                  >
                    <div className='value-table__company-name'>
                      {application.name ? application.name : '-'}
                    </div>
                  </Tippy>
                </td>
                <td className='value-table'>
                  <Tippy
                    duration={10}
                    distance={24}
                    arrowType='sharp'
                    delay={[500, 0]}
                    placement='bottom'
                    followCursor={true}
                    html={
                      <div className='data-table__tooltip'>
                        {application.address}
                      </div>
                    }
                  >
                    <div className='value-table__address'>
                      {application.address ? application.address : '-'}
                    </div>
                  </Tippy>
                </td>
                <td className='value-table'>
                  <Tippy
                    duration={10}
                    distance={24}
                    arrowType='sharp'
                    delay={[500, 0]}
                    placement='bottom'
                    followCursor={true}
                    html={
                      <div className='data-table__tooltip'>
                        {application.tel}
                      </div>
                    }
                  >
                    <div className='value-table__address'>
                      {application.tel ? application.tel : '-'}
                    </div>
                  </Tippy>
                </td>
                <td className='value-table'>
                  <div
                    className='value-table__date'
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    {!_.isNull(application.one_master_flag) &&
                    application.one_master_flag === ONE_MASTER_FLAG.personal.id
                      ? ONE_MASTER_FLAG.personal.name
                      : ONE_MASTER_FLAG.corporation.name}
                  </div>
                </td>
                <td className='value-table'>
                  <div className='AgencyRegistrationApplications__status-box'>
                    <AgencyRegistrationApplicationStatus
                      status={application.latest_application_status}
                    />
                    <button
                      className='btn'
                      onClick={() => {
                        moveDetailPage(application.latest_application_id);
                      }}
                    >
                      最新の申請を確認
                    </button>
                  </div>
                </td>
                <td className='value-table value-table--button'>
                  <div className='value-table__button-'>
                    <button
                      className='btn--sub'
                      onClick={() =>
                        showAgencyRegistrationApplicationHistoryDialog(
                          application
                        )
                      }
                    >
                      申請履歴
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AgencyRegistrationApplications;



// WEBPACK FOOTER //
// ./src/pages/AgencyRegistrationApplications.jsx